import { useMutation } from '@tanstack/react-query'
import { addContributorScore } from '../services/functional_summaries';

const AddContributorScore = () => {
 const contributorScore = useMutation({
    queryKey:['contributor_score'],
    mutationFn: addContributorScore
 })
 return contributorScore;
}

export default AddContributorScore